module.exports = __webpack_public_path__ + "static/media/2D.e3f637b3.jpg";